import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { UserOpponentsDetailsFilters, COLUMNS_NAME } from './constants';
import useService from './useService';

const useOpponentsDetails = (isCollapsed: any) => {
	const { getUserOpponentDetails, uid } = useService();
	const [userOpponentsData, setUserOpponentsData] = useState<any>({ data: [], rowCount: 0 });
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [filters, setFilters] = useState<UserOpponentsDetailsFilters>();
	const [showLoader, setShowLoader] = useState<boolean>(false);
	const [confirmation, setConfirmation] = useState<boolean>(false);
	const [callFetchData, setCallFetchData] = useState<boolean>(false);

	const fetchUserOpponentsData = async () => {
		try {
			setShowLoader(true);
			const result = await getUserOpponentDetails(filters);

			setUserOpponentsData({ data: result.data, rowCount: result?.rowCount });
			setForceUpdate(true);
		} catch (error: any) {
			setUserOpponentsData({ data: [], rowCount: 0 });
			setForceUpdate(true);
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (filters && callFetchData) {
			setConfirmation(false);
			setCallFetchData(false);
			fetchUserOpponentsData();
		}
	}, [filters, callFetchData]);

	const getUserOpponentsData = () => {
		setForceUpdate(false);
		return userOpponentsData;
	};

	const downloadCsvFile = () => {
		const csvString = [
			COLUMNS_NAME,
			...userOpponentsData.data.map((item: any) => [
				Number(item.zupeeuserid),
				item.ludotournamentid,
				item.playingtableid,
				item.game_type,
				item.entryfee,
				item.totalseats,
				dayjs(item.eventTime).format('DD-MM-YYYY HH:mm:ss'),
				item.deviceid,
				item.useripaddr,
				Number(item.opp_zupeeuserid),
				item.opp_deviceid,
				item.opp_ipaddr,
				item.opp_username,
				item.opp_phoneno,
				item.opp_emailId,
				item.opp_UPI,
				item.opp_bankAccountNo,
				item.opp_bankAccountHolder,
				item.opp_bankAccountIFSC
			])
		]
			.map((e) => e.join(','))
			.join('\n');
		const csvContent = `data:text/csv;charset=utf-8, ${csvString}`;
		const encodedUri = encodeURI(csvContent);

		const link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', `userOpponentsDetails_${uid}.csv`);
		document.body.appendChild(link);
		link.click();
	};

	const handleFilterSubmit = (submittedFilters: { fromToDate?: Date[] }) => {
		const { fromToDate } = submittedFilters;

		if (fromToDate && fromToDate.length === 2) {
			setFilters({ userOpponentsDetailsFrom: fromToDate[0].getTime(), userOpponentsDetailsTill: fromToDate[1].getTime() });
			setConfirmation(true);
		}
	};

	const confirmationDialogOnAgree = () => {
		setConfirmation(false);
		setCallFetchData(true);
	};

	const confirmationDialogOnClose = () => {
		setConfirmation(false);
		isCollapsed(true);
	};

	return {
		getUserOpponentsData,
		handleFilterSubmit,
		forceUpdate,
		showLoader,
		downloadCsvFile,
		confirmation,
		confirmationDialogOnClose,
		confirmationDialogOnAgree
	};
};

export default useOpponentsDetails;
